import { ApiCreatePersonRequest, ApiUpdatePersonRequest } from '@agunity/api-v4';
import { apiService } from '../../api/apiService';
import { ApiCheckForDuplicate, ApiCreateOrgPerson, ApiCustomFieldRequest } from '@agunity/api-v4/build/data-contracts';

export const getUser =
  (userId: number) =>
    async () => {
      const response = await apiService.profileV42FullDetail(userId);
      return response;
    };

export const getMemberProfile =
  (userId: number) =>
    async () => {
      const response = await apiService.profileV42FullDetail(userId);
      return response;
    };

export const updateUserStatus =
  (identityId: number, isActive: boolean) =>
    async () => {
      const response = await apiService.identityV10ItemActiveFlagPartialUpdate(identityId, isActive);
      return response;
    };

export const getRoles =
  () =>
    async () => {
      const response = await apiService.roleV20ItemsFullList();
      return response;
    };

export const saveUser =
  (data: ApiCreatePersonRequest) =>
    async () => {
      const response = await apiService.accountV11ItemCreate(data);
      return response;
    };

export const updateUser =
  (data: ApiUpdatePersonRequest) =>
    async () => {
      const response = await apiService.accountV11ItemPartialUpdate(data);
      return response;
    };

export const verifyEmail =
  (email: string) =>
    async () => {
      const response = await apiService.identityV10EmailUsedDetail(email);
      return response;
    };

export const getOrgAddress =
  (orgId: number) =>
    async () => {
      const response = await apiService.organizationV10AddressDetail(orgId);
      return response;
    };

export const getOrgRoles =
  (orgId: number) =>
    async () => {
      const response = await apiService.roleV10RolesForOrgDetail(orgId);
      return response;
    };

export const getCustomFieldList =
  () =>
    async () => {
      const response = await apiService.customFieldV10ListList();
      return response;
    };

export const getCustomFieldByTagAndFunction =
  (data: ApiCustomFieldRequest) =>
    async () => {
      const response = await apiService.customFieldV11ListCreate(data);
      return response;
    };

export const getEnumList =
  () =>
    async () => {
      const response = await apiService.enumV10ListList();
      return response;
    };

export const addNewMember =
  (data: ApiCreateOrgPerson) =>
    async () => {
      const response = await apiService.profileV10ItemCreate(data);
      return response;
    };

export const addNewStaff =
  (data: ApiCreatePersonRequest) =>
    async () => {
      const response = await apiService.profileV10StaffCreate(data);
      return response;
    };

export const checkDuplicatedPersonName =
  ( orgId: number, data: ApiCheckForDuplicate) =>
    async () => {
      const response = await apiService.organizationV10CheckForDuplicatePersonNameCreate(orgId, data);
      return response;
    };

export const checkDuplicatedEmail =
  ( email: string ) =>
    async () => {
      const response = await apiService.accountV10EmailUsedDetail(email);
      return response;
    };
    
export const updateIdentity =
  (data: any) =>
    async () => {
      const response = await apiService.accountV11ItemPartialUpdate(data);
      return response;
    };
    